import { createReducer } from '@reduxjs/toolkit';
import { createTableStateReducers } from '@/store/tableState.reducer';

const initialState = {
  tableState: {
    pageSize: 20,
    pageIndex: 0,
  },
};

export default createReducer(initialState, (builder) => {
  Object.entries(createTableStateReducers('EXCHANGE_RATES')).forEach(
    ([actionType, reducer]) => {
      builder.addCase(actionType, reducer);
    },
  );
});
